(function () {
  'use strict';

  var sourceId = 'md-size-check-source';
  var noticeClass = 'md-size-check';

  function placeSizeCheckNotice() {
    var source = document.getElementById(sourceId);
    if (!source) return;

    var sourceNotice = source.querySelector('.' + noticeClass);
    if (!sourceNotice) return;

    var actions = document.querySelector('.comp-product-actions');
    if (!actions) return;

    /* Vue renders the product controls from site.js, so the Liquid notice has
       to be moved into the rendered component after Vue has mounted. */
    if (actions.querySelector('.' + noticeClass)) return;

    var notice = sourceNotice.cloneNode(true);
    var form = actions.querySelector('form');

    if (form) {
      actions.insertBefore(notice, form);
    } else {
      actions.appendChild(notice);
    }
  }

  function initSizeCheckNotice() {
    placeSizeCheckNotice();

    /* Keep watching because Vue can render/re-render the product actions after
       DOMContentLoaded or when the selected variant changes. */
    var observer = new MutationObserver(function () {
      placeSizeCheckNotice();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeCheckNotice);
  } else {
    initSizeCheckNotice();
  }
})();
